<elder-single-pane-wrapper>
  <!-- Main Tabs -->
  <mat-tab-group class="flex" animationDuration="0ms">
    <!-- General -->
    <mat-tab label="{{ 'common.general' | translate }}">
      <div class="flex layout-col gap-md p-sm mat-typography">
        <!-- Content -->
        <elder-card>
          <elder-card-header>
            <elder-card-title>{{ 'common.general' | translate }}</elder-card-title>
          </elder-card-header>

          <elder-card-content>
            <form #frm="ngForm" class="flex layout-col">
              <div class="layout-row gap-xl">
                <!-- Language -->
                <div class="flex layout-col">
                  <h4 elderCardSubtitle>{{ 'settings.languages.title' | translate }}</h4>

                  <elder-language-switcher></elder-language-switcher>
                </div>
              </div>
            </form>
          </elder-card-content>
        </elder-card>
      </div>
    </mat-tab>

    <!-- General -->
    <mat-tab label="{{ 'common.optimisation' | translate }}">
      <div class="flex layout-col gap-md p-sm mat-typography">
        <!-- Content -->
        <elder-card>
          <elder-card-header>
            <elder-card-title>{{ 'algorithm.title' | translate }}</elder-card-title>

            <elder-card-header-actions>
              <button mat-icon-button name="save" [disabled]="!frm.form.valid" (click)="onSave()">
                <mat-icon>save</mat-icon>
              </button>
            </elder-card-header-actions>
          </elder-card-header>

          <elder-card-content>
            @if (settings(); as settings) {
              <form class="layout-col">
                <div class="layout-row gap-xl">
                  <div class="flex layout-col gap-lg">
                    <h4 elderCardSubtitle>{{ 'common.general' | translate }}</h4>
                    <mat-form-field>
                      <input matInput name="id" disabled [ngModel]="settings.id"/>
                      <mat-label>{{ 'common.id' | translate }}</mat-label>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        name="maxNumberOfIterations"
                        type="number"
                        required
                        min="1"
                        pattern="[0-9]*"
                        [(ngModel)]="settings.maxNumberOfIterations"
                      />
                      <mat-label>{{ 'algorithm.maxNumberOfIterations' | translate }}</mat-label>
                    </mat-form-field>
                    <mat-form-field>
                      <input
                        matInput
                        name="populationSize"
                        type="number"
                        required
                        min="1"
                        pattern="[0-9]*"
                        [(ngModel)]="settings.populationSize"
                      />
                      <mat-label>{{ 'algorithm.populationSize' | translate }}</mat-label>
                    </mat-form-field>
                    <mat-checkbox
                      name="recordProgress"
                      [(ngModel)]="settings.recordProgress"
                      [labelPosition]="'after'"
                    >
                      {{ 'algorithm.recordProgress' | translate }}
                    </mat-checkbox>

                    <mat-form-field>
                      <input
                        matInput
                        name="dmObjective"
                        required
                        [(ngModel)]="settings.dmObjective"
                      />
                      <mat-label>{{ 'algorithm.objectiveFunction' | translate }}</mat-label>
                    </mat-form-field>

                    <mat-form-field>
                      <input
                        matInput
                        name="costWeight"
                        required
                        type="number"
                        min="1"
                        [(ngModel)]="settings.fitnessWeights.cost"
                      />
                      <mat-label>{{ 'algorithm.functionWeight' | translate }}</mat-label>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            }
          </elder-card-content>
        </elder-card>
      </div>
    </mat-tab>
  </mat-tab-group>
</elder-single-pane-wrapper>
